import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { useI18n } from "@/lib/i18n";

export default function Privacy() {
  const { t, lang, isRTL } = useI18n();

  useEffect(() => {
    document.title = lang === "ar" ? "سياسة الخصوصية · ركنتي" : "Privacy Policy · Raknati";
  }, [lang]);

  const sections = t("privacy.sections");

  return (
    <main className="pt-28 md:pt-32 pb-20 bg-white" data-testid="privacy-page">
      <div className="container-x max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand-charcoal/70 hover:text-brand-green transition-colors duration-200"
          data-testid="privacy-back"
        >
          <ArrowLeft className={`h-4 w-4 ${isRTL ? "rotate-180" : ""}`} />
          {lang === "ar" ? "العودة" : "Back"}
        </Link>

        <div className="mt-8">
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-brand-green">
            {t("privacy.updated")}
          </div>
          <h1 className="h1 mt-3">{t("privacy.title")}</h1>
          <p className="lede mt-5">{t("privacy.intro")}</p>
        </div>

        <div className="mt-12 space-y-6">
          {sections.map((s, i) => (
            <div key={i} className="rounded-2xl border border-brand-line bg-white p-6" data-testid={`privacy-section-${i}`}>
              <div className="flex items-baseline gap-3">
                <div className="text-xs font-bold text-brand-green">{String(i + 1).padStart(2, "0")}</div>
                <div className="text-base font-bold text-brand-charcoal">{s.t}</div>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-brand-charcoal/70">{s.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-brand-sand border border-brand-line p-6 text-sm text-brand-charcoal/70">
          {t("privacy.disclaimer")}
        </div>
      </div>
    </main>
  );
}
